window.onload = function () {
  	

 
 var arrow = '<svg class="ml-1 px-1" width="22px" height="35px" viewbox="0 0 22 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="REN_Find-a-Retailer-Copy-4" transform="translate(-689.000000, -433.000000)" fill="#FFFFFF"> <g id="Group-2" transform="translate(689.500000, 433.500000)"> <polygon id="Triangle" points="10.5 0 21 15 0 15"></polygon> <polygon id="Triangle-Copy" transform="translate(10.500000, 26.500000) rotate(-180.000000) translate(-10.500000, -26.500000) " points="10.5 19 21 34 4.54747351e-13 34"></polygon> </g> </g> </g> </svg>';

    $('.world a').click(function() {
  $('.select-state').removeClass('open');
  $('.dropdown').removeClass('hover');
});
  

// $('.search').click(function() {
//   $('#countries-list').toggleClass('open');
// });
  
// $('#countries-list li a').click(function() {
// 	var country = $(this).text();
//   	$('#select-country').html(country + arrow);
// });

// $("#united-states").click(function() {
//   $('.select-state').addClass('open');
// //   $('#states').addClass('open');
// });
  
$('.select-state').click(function() {
  $('#states').toggleClass('open');
});

$('.world').click(function() {
  $('.select-state').removeClass('open');
  $('#states').removeClass('open');
  $('.store-details').removeClass('open');
  var id = '.' + $(this).attr('id');
   $(id).addClass('open');
  
})

$('#states li a').click(function() {
  $('.store-details').removeClass('open');
  var id = '.' + $(this).attr('id');
  $(id).addClass('open');
  $('.store-details').addClass('closed');
    //    $('.select-state').removeClass('open');        
  $('#states').removeClass('open');
  var state = $(this).text();
  	$('.select-state').html(state + arrow);
  });
  
  
  
  
  

  $('.second-button').on('click', function () {

    $('.animated-icon2').toggleClass('open');
  });
  //var video = $('#home-video');

  $("#play_button").on("click", function () {
    if (jwplayer().getState() == "paused" || jwplayer().getState() == "idle") {
      jwplayer().play();
      $(".banner-image-large_text").fadeOut(400);
    } else {
      jwplayer().pause();
    }
  });
  $(".jw-video").on("click", function () {
    if (jwplayer().getState() == "paused" || jwplayer().getState() == "idle") {
      $(".banner-image-large_text").fadeOut(400);
    }
  });
  $(".jw-player").on("click", function () {
    if (jwplayer().getState() == "paused" || jwplayer().getState() == "idle") {
      jwplayer().play();
      $(".banner-image-large_text").fadeOut(400);
    }
  });
    $(".banner-image-large_text").on("click", function () {
    if (jwplayer().getState() == "paused" || jwplayer().getState() == "idle") {
      jwplayer().play();
      $(".banner-image-large_text").fadeOut(400);
    }
  });
  /*
  jwplayer().on("pause", function (event) {
    $(".banner-image-large_text").fadeIn(400);
  });
  */
  //$('.banner-image-large_text').fadeIn(400);

  /*
	$(video).on('play', function() {
		$('.banner-image-large_text').fadeOut(400);
	});

	$(video).on('pause', function() {
		$('.banner-image-large_text').fadeIn(400);
	});
  */
  
  window.onscroll = function() {scrollFunction()};
  
  function scrollFunction() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        $('.back-to-top-wrapper').css('display', 'block')

      } else {
        $('.back-to-top-wrapper').css('display', 'none')
      }
  }
  
  var $window = $(window);
 
$(window).on('scroll', function() {
//     $topOffset = $(this).scrollTop();
 
    if($(window).scrollTop() + $(window).height() < $(document).height() - $('footer').height() ){
//       console.log($(window).scrollTop() + $(window).height());
      $('.back-to-top-wrapper').removeClass('bottom');
    } else {
      $('.back-to-top-wrapper').addClass('bottom');
    }
 
});
  
  //Comfort Zone mobile toggle
  if (window.matchMedia("(max-width: 767.98px)").matches) {
    $('.comfort_cell').on('click', function () {
      $('.comfort_cell').not(this).removeClass('open');
      $(this).toggleClass('open');
    });
  }
  
  
    
  
//   // When the user clicks on the button, scroll to the top of the document
// function topFunction() {
//   document.body.scrollTop = 0; // For Safari
//   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
// }
  
  
  

}




